import Login from 'views/Pages/Login.jsx'
import Page404 from 'views/Pages/404.jsx'
import TechnicalIssues from 'views/Pages/TechnicalIssues.jsx'
import News from 'views/News/News.jsx'
import NewsRoute from 'views/News/NewsRoute.jsx'
import NewsDesc from 'views/News/NewsDesc.jsx'
import Profile from 'views/Profile/Profile.jsx'
import Register from 'views/Pages/Register.jsx'
import PasswordRecovery from 'views/Pages/PasswordRecovery.jsx'
import Events from 'views/Events/Events.jsx'
import EventDesc from 'views/Events/EventDesc.jsx'
import Terms from 'views/Terms/Terms.jsx'
import Webinars from 'views/Webinars/Webinars.jsx'
import WebinarDesc from 'views/Webinars/WebinarDesc.jsx'
import Cinema from 'views/Cinema/Cinema.jsx'
import Story from 'views/Story/Story.jsx'
import StoryDesc from 'views/Story/StoryDesc.jsx'
import Catalog from 'views/Catalog/Catalog.jsx'
import ItemDesc from 'views/Catalog/ItemDesc.jsx'
import Cart from 'views/Cart/Cart.jsx'
import Study from 'views/Study/Study.jsx'
import StudyDesc from 'views/Study/StudyDesc.jsx'
import Authors from 'views/Authors/Authors.jsx'
import AuthorDesc from 'views/Authors/AuthorDesc.jsx'
import Test from 'views/Study/Test.jsx'
import FilmDesc from 'views/Cinema/FilmDesc.jsx'
import Partners from 'views/Partners/Partners.jsx'
import PartnerDesc from 'views/Partners/PartnerDesc.jsx'
import Sale from 'views/Sale/Sale.jsx'
import SaleRoute from '../views/Sale/SaleRoute.jsx'
import Main from 'views/Main/Main.jsx'
import Search from 'views/Search/Search.jsx'
import UserEvents from 'views/Calendar/UserEvents.jsx'
import Certificate from 'views/Study/Certificate.jsx'
import Favorite from 'views/Favorite/Favorite.jsx'
import Logs from 'views/Logs/Logs.jsx'
import StudyHistory from 'views/StudyHistory/StudyHistory.jsx'
import CatalogRoute from '../views/Catalog/CatalogRoute.jsx'
import Bill from '../views/Cart/Bill.jsx'
import {
    HouseLine,
    NewspaperClipping,
    ShoppingBagOpen,
    Tag,
    Users,
    Briefcase,
    BookOpen,
    VideoCamera,
    CalendarBlank,
    ChartLineUp,
    Package,
    PlayCircle,
} from "phosphor-react"
import PageDesc from '../views/Pages/PageDesc.jsx'

const dashRoutes = [
    {
        path: '/main',
        name: 'dashboard-main',
        icon: HouseLine,
        component: Main,
    },

    {
        path: '/news-route',
        name: 'dashboard-news',
        icon: NewspaperClipping,
        component: NewsRoute,
    },

    {
        path: '/catalog-route',
        name: 'dashboard-catalog',
        icon: ShoppingBagOpen,
        component: CatalogRoute,
    },

    {
        path: '/sale-route',
        name: 'dashboard-sale',
        icon: Tag,
        component: SaleRoute,
    },

    {
        path: '/authors',
        name: 'dashboard-authors',
        icon: Users,
        component: Authors,
    },

    {
        path: '/study',
        name: 'dashboard-study',
        icon: Briefcase,
        component: Study,
    },

    {
        path: '/stories',
        name: 'dashboard-story',
        icon: BookOpen,
        component: Story,
    },

    {
        path: '/webinars',
        name: 'dashboard-webinars',
        icon: VideoCamera,
        component: Webinars,
    },

    {
        path: '/events',
        name: 'dashboard-events',
        icon: CalendarBlank,
        component: Events,
    },

    {
        path: '/partners',
        name: 'dashboard-projects',
        icon: ChartLineUp,
        component: Partners,
    },

    {
        path: '/knowledge',
        name: 'dashboard-knowledge',
        icon: Package,
        component: Terms,
    },

    {
        path: '/cinema',
        name: 'dashboard-cinema',
        icon: PlayCircle,
        component: Cinema,
    },

    { path: '/calendar', component: UserEvents, type: 'child' },
    { path: '/favorite', component: Favorite, method: 'favorite', type: 'child' },
    { path: '/cart', component: Cart, type: 'child' },
    { path: '/bill/:billId', component: Bill, type: 'child' },
    { path: '/search', component: Search, type: 'child' },
    { path: '/catalog/:page', component: Catalog, type: 'child' },
    { path: '/sale/:page', component: Sale, type: 'child' },
    { path: '/logs/:page', component: Logs, type: 'child' },
    { path: '/study-history/:page', component: StudyHistory, type: 'child' },
    { path: '/news/:page', component: News, type: 'child' },
    { path: '/new/:newId', component: NewsDesc, type: 'child' },
    { path: '/page/:uri', component: PageDesc, type: 'child' },
    { path: '/item/:itemId', component: ItemDesc, type: 'child' },
    { path: '/story/:storyId', component: StoryDesc, type: 'child' },
    { path: '/author/:authorId', component: AuthorDesc, type: 'child' },
    { path: '/event/:eventId', component: EventDesc, type: 'child' },
    { path: '/webinar/:webinarId', component: WebinarDesc, type: 'child' },
    { path: '/film/:filmId', component: FilmDesc, type: 'child' },
    { path: '/project/:projectId', component: PartnerDesc, type: 'child' },
    { path: '/course/:courseId/mod/:modId', component: StudyDesc, type: 'child' },
    { path: '/course/:courseId/test/:testId', component: Test, type: 'child' },
    { path: '/course/complete/:courseId', component: Certificate, type: 'child' },
    { path: '/profile', component: Profile, type: 'child' },
    { path: '/register', component: Register, type: 'child' },
    { path: '/login', component: Login, type: 'child' },
    { path: '/request-password-recovery', component: PasswordRecovery, type: 'child' },
    { path: '/404', component: Page404, type: 'child' },
    { path: '/technical-issues', component: TechnicalIssues, type: 'child' },
    { redirect: true, path: '/', pathTo: '/login', name: 'login' },
]

export default dashRoutes



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx